import React from 'react';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import { DashboardDocument } from './DashboardDocument';
import DashboardDialog from './DashboardDialog';

export interface DashboardSelectionButtonPreloadedProps {
  selectedDashboard: DashboardDocument | undefined;
  setSelectedDashboard?: (dashboard: DashboardDocument | undefined ) => void;

  limitToTemplateDashboards?: boolean;

  size?: "small" | "medium" | "large";

  variant?: "text" | "outlined" | "contained";
}

export default function DashboardSelectionButtonPreloaded(props: DashboardSelectionButtonPreloadedProps): JSX.Element {
  const { i18n } = useTranslation();

  const { selectedDashboard, setSelectedDashboard } = props;

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  let displayName = i18n.t('resources.dashboards.select-dashboard');
  if (selectedDashboard) {
    displayName = selectedDashboard.name;
    // Use a truncated dashboard name if it is too long
    if (displayName.length > 30) {
      displayName = displayName.substring(0, 30) + "...";
    }
  }

  let variant = selectedDashboard ? "outlined" : "contained";
  if (props.variant) {
    variant = props.variant;
  }

  return (
  <>
    <Button
      variant={variant}
      onClick={() => setDialogOpen(true)}
      size={props.size || "medium"}
      endIcon={<EditIcon />}>
      {displayName}
    </Button>
    {dialogOpen &&
      <DashboardDialog
        open={dialogOpen}
        limitToTemplateDashboards={props.limitToTemplateDashboards}
        onClose={() => setDialogOpen(false)}
        onSubmit={(dashboard: DashboardDocument | undefined) => {
          if (dashboard === undefined) {
            return;
          }
          setSelectedDashboard(dashboard);
          setDialogOpen(false);
        }}
      />
    }
  </>
  );
}